import { useState, useEffect, useRef } from "react";
import { Link } from "@/components/common/Link";
export default function DevotionalBlock() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return <section style={{
    backgroundColor: "#F5F4F2",
    color: "rgb(33, 33, 31)",
    fontFamily: "Switzer, sans-serif"
  }} className="w-full overflow-hidden">
      <div ref={ref} className={`w-full transition-opacity duration-700 ${visible ? "opacity-100" : "opacity-0"}`}>
        <div className="w-full relative flex items-center justify-center" style={{
        marginTop: "6rem",
        marginBottom: "3rem"
      }}>
          <img alt="" className="w-full h-auto block" src="https://current-thrush.10web.cloud/wp-content/uploads/2026/08/DEVOCIONAL.png" />
          <div className="absolute inset-0 flex items-center justify-center">
            <img alt="Devotionals" style={{
            width: "33.5%",
            maxWidth: "616px",
            height: "auto",
            borderTopLeftRadius: "50%",
            borderTopRightRadius: "50%",
            borderBottomRightRadius: "50%",
            borderBottomLeftRadius: "0px"
          }} src="https://current-thrush.10web.cloud/wp-content/uploads/2026/08/devocional1.png" />
          </div>
        </div>

        <div className="flex flex-col items-center text-center px-6" style={{
        paddingBottom: "3rem"
      }}>
          <p style={{
          color: "rgb(33, 33, 31)",
          fontFamily: "Switzer, sans-serif",
          fontSize: "20px",
          fontWeight: "300",
          lineHeight: "28px",
          border: "0px none rgb(33, 33, 31)",
          textAlign: "center",
          maxWidth: "600px",
          marginBottom: "24px"
        }}>
            Participe en devocionales como el diario Palabra de Dios para Hoy
            <br />
            que ofrecen guía, inspiración e interacción con la Biblia.
          </p>

          <Link to="#" className="inline-flex items-center gap-2 cursor-pointer hover:opacity-90 transition-all duration-150" style={{
          color: "rgb(255, 255, 255)",
          fontFamily: "Switzer-Light, Switzer, sans-serif",
          fontSize: "14px",
          fontWeight: "500",
          lineHeight: "21px",
          backgroundColor: "rgb(53, 53, 51)",
          borderRadius: "28px",
          border: "1px solid rgb(53, 53, 51)",
          padding: "4px 4px 4px 12px",
          textTransform: "uppercase",
          textAlign: "center",
          textDecoration: "none"
        }}>
            MÁS INFORMACIÓN
            <span className="inline-flex items-center justify-center" style={{
            width: "24px",
            height: "24px",
            borderRadius: "50%",
            backgroundColor: "#fff",
            flexShrink: 0
          }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M2.5 9.5L9.5 2.5M9.5 2.5H4M9.5 2.5V8" stroke="rgb(33,33,31)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
          </Link>
        </div>
      </div>
    </section>;
}